export default __webpack_public_path__ + "static/media/expire-icon.024cb73c.svg";